import DashboardHighlights from 'components/DashboardHighlights'
import { Highlights } from 'pages/Dashboard/types'
import { useSelector } from 'react-redux'
import { getAffiliate } from 'store/selectors'

export type HighlightsContainerProps = {
  highlights: Highlights[]
}

export default function HighlightsContainer(props: HighlightsContainerProps) {
  const affiliate = useSelector(getAffiliate)

  if (!affiliate?.name) {
    return null
  }

  if (!props.highlights) {
    return null
  }

  const getStrucuturedHighlights = () => {
    return props.highlights.map((h) => {
      if (h.link.url.includes('/tools')) {
        return {
          ...h,
          link: {
            ...h.link,
            url: (h.link.url as string).replace('/tools', ''),
          },
        }
      }

      if (h.useCustomLink) {
        const GAMES_SITE_URL = import.meta.env.VITE_GAMES_SITE_URL
        const MAIN_SITE_URL = import.meta.env.VITE_MAIN_SITE_URL
        const link = { text: null, url: null }
        link.text = h.customLinkText

        switch (h.customLink) {
          case 'directory_page':
            link.url = `${MAIN_SITE_URL}/affiliate/${affiliate?.id}/${affiliate?.slug}`
            break
          case 'games_affiliate_page':
            link.url = `${GAMES_SITE_URL}/affiliate/${affiliate?.id}`
            break
          default:
            break
        }

        return {
          ...h,
          link,
        }
      }

      return h
    })
  }
  const highlights = getStrucuturedHighlights()

  return (
    <>
      <DashboardHighlights
        highlights={highlights}
        affiliateId={String(affiliate.id)}
        affiliateSlug={affiliate.slug}
      />
    </>
  )
}
